import { render, staticRenderFns } from "./biddingLinks.vue?vue&type=template&id=2deade3a&scoped=true&"
import script from "./biddingLinks.vue?vue&type=script&lang=js&"
export * from "./biddingLinks.vue?vue&type=script&lang=js&"
import style0 from "./biddingLinks.vue?vue&type=style&index=0&id=2deade3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deade3a",
  null
  
)

export default component.exports